import React from "react";
import { SettingContext } from "./App";



const iaam_conf = {
    op_host: process.env.REACT_APP_IAAM_GATEWAY_HOST,
    iaamgw_host: process.env.REACT_APP_IAAM_GATEWAY_HOST, 
    client_id: process.env.REACT_APP_CLIENT_ID,
    post_logout_uri: process.env.REACT_APP_POST_LOGOUT_URL
}
const iaam = window.iaam;
    
const getDPC = async (prov_code) => {
    let options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json', 
            // 'Authorization': `bearer ${access_token}`
        }
    }
    const data = await fetch(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_MASTER_PREFIX}/dpc/get_dpc_with_prov_code?prov_code=${prov_code}`, options);
    const json = await data.json()
    return json
}

const getApps = async (inum) => {
    let options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json', 
            // 'Authorization': `bearer ${access_token}`
        }
    }
    const data = await fetch(`${process.env.REACT_APP_IAAMREG_HOST}/iaam-api/applications?inum=${inum}&app_type=WEB`, options);
    const json = await data.json()
    let apps = json.filter((item) => {return item.client_name !== process.env.REACT_APP_CLIENT_NAME? true : false})
    return apps.map((item) => {return {...item, client_name:item.client_name.split("-").join(" ")}})
}

const IAAMLogin = () => {
    const { dispatch } = React.useContext(SettingContext);
    iaam.initLoginFlow(iaam_conf)
    .then((init) => {
        iaam.isLoggedIn((error, status)=>{
            if(!status){
                iaam.login()
            }
            else{
                iaam.getProfile(async (err, profile) => {  
                    if(!err){
                        let dpc = await getDPC(profile.province_code)
                        profile["dpc_code"] = dpc.health_region_code
                        profile["dpc_name"] = dpc.health_region_name

                        let apps = await getApps(profile.inum)
                        profile["apps"] = apps

                        dispatch({
                            type: "LOGIN",
                            iaam: iaam,
                            profile: profile
                        })
                    }
                    else{
                        iaam.login()
                    }
                })
                
            }
        })
    })
    return (<></>)
}

export default IAAMLogin